import React, {Component} from "react";
import {Row, Col, Card, CardBody} from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";

import {connect} from "react-redux";
import {
  approveProfessional, editProfessional,
  getProfessionals,
  removeProfessional,
  resetProfessionalQuery
} from "../../store/professionals/actions";
import ShelterList from "./List/ShelterList";
import {userRols} from "../../helpers/userRols";
import Paging from "../../components/Pagination/Pagination";
import LoadingCard from "../../components/LoadingCard/LoadingCard";
import ListSearch from "components/ListSearch/ListSearch";

class Shelters extends Component {
  constructor(props) {
    super(props);

    this.onNewClinicModal = this.onNewClinicModal.bind(this);
    this.onRemove = this.onRemove.bind(this);
    this.onEdit = this.onEdit.bind(this);
  }

  componentDidMount() {
    this.props.getProfessionals({type: userRols.shelter});
  }

  setPage = (currentPage) => {
    this.props.getProfessionals({
      type: userRols.shelter,
      page: currentPage
    });
  }

  setPageSize = (pageSize) => {
    this.props.getProfessionals({
      type: userRols.shelter,
      pageSize,
      page: 1
    });
  }

  refreshPage = () => {
    this.props.resetProfessionalQuery();
    this.props.getProfessionals({type: userRols.shelter});
  }

  onNewClinicModal() {
    this.props.showAddClinicModal(!this.props.isAddNewClinicOpen);
  }

  onRemove(shelter) {
    this.props.removeProfessional(shelter, userRols.shelter);
  }

  onEdit(shelter) {
    this.props.editProfessional(shelter);
  }

  handleSearch = (q) => {
    this.props.getProfessionals({
      type: userRols.shelter,
      q,
      page: 1
    });
  }

  render() {
    const {professionalList, approveProfessional, loadingProfessionals, query} = this.props;
    const { page: currentPage, pageSize, q } = query;
    
    // Extract data from the paginated response
    const shelters = professionalList?.users || [];
    const total = professionalList?.total || 0;
    const pages = professionalList?.pages || 1;

    return (
      <React.Fragment>
        <div className="page-content">
          <div className="container-fluid">
            <Breadcrumbs title="Приюти" breadcrumbItem="Приюти"/>

            <Row>
              <Col>
                {!loadingProfessionals ? (
                  <Card>
                    <CardBody>
                      {/* Header with pagination and search */}
                      <div className="list-toolbar mb-3">
                        <Paging
                          setPage={this.setPage}
                          setPageSize={this.setPageSize}
                          pageSize={pageSize}
                          currentPage={currentPage}
                          pages={pages}
                        />

                        <ListSearch
                          value={q || ""}
                          onSearch={this.handleSearch}
                          placeholder="Търсене по име, имейл или телефон"
                        />
                      </div>

                      <div className="mb-2 text-muted">
                        Общо: {total} приюта
                      </div>

                      <ShelterList
                        list={{users: shelters}}
                        onRemoveItem={this.onRemove}
                        onEditItem={this.onEdit}
                        onApproveItem={approveProfessional}
                        history={this.props.history}
                      />
                    </CardBody>
                    <Paging 
                      setPage={this.setPage} 
                      setPageSize={this.setPageSize} 
                      pageSize={pageSize} 
                      currentPage={currentPage}
                      pages={pages}
                    />
                  </Card>
                ) : (
                  <LoadingCard />
                )}
              </Col>
            </Row>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = (state) => {
  const {Professional} = state;
  const query = Professional.query || { page: 1, pageSize: 20, type: '' };
  return {...Professional, query};
};

export default connect(mapStatetoProps, {
  getProfessionals,
  approveProfessional,
  removeProfessional,
  editProfessional,
  resetProfessionalQuery
})(Shelters);
